export const siteCopyMain = [
  {
    name: 'site_copy',
    path: '/site_copy',
    icon: 'el-icon-copy-document',
    component: () => import('/@/views/plugins/site_copy/index.vue'),
    meta: {
      title: '站点复制',
      icon: 'el-icon-copy-document'
    }
  }
]
